import React, { PropsWithChildren } from "react";
//#region types
import { FooterWithDividerProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Divider, Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const FooterWithDivider: React.FC<PropsWithChildren<FooterWithDividerProps>> = (props) => {
  return (
    <Grid item container direction="column" className={cssExports.footerWithDivider}>
      <Grid item container className={cssExports.dividerContainer}>
        <Divider orientation="horizontal" flexItem className={cssExports.divider} />
      </Grid>
      {props.footerTitle ? (
        <Grid item container className={cssExports.footerWithDividerTitle}>
          {props.footerTitle}
        </Grid>
      ) : (
        <></>
      )}
      {props.children ? (
        <Grid item container>
          {props.children}
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default FooterWithDivider;
